<template>
  <eye-exam-card
    class="medical-record-exam-view"
    title="OPD"
    :patient-id="patientId"
    :record-id="recordId"
    :exam-id="examId"
    :inputs="data"
    :rows-definition="table.body"
    :date="date"
    @edit="$emit('edit')"
    :show-edit-button="showEditButton"
  />
</template>

<script>
import formatters from '@/filters';
import EyeExamCard from '../ophtalmology/EyeExamCard.vue';

export default {
  name: 'OpdView',
  components: {
    EyeExamCard,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    patientId: {
      type: String,
      required: false,
    },
    recordId: {
      type: String,
      required: false,
    },
    examId: {
      type: String,
      required: false,
    },
    date: {
      type: String,
      required: false,
    },
    showEditButton: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      table: {
        body: [
          {
            label: 'Refraction Center',
            R: 'refractionR',
            L: 'refractionL',
            formatter: v => v || '',
          },
          {
            label: 'Astigmatismo DK (mapa axial)',
            R: 'astigmatismDkR',
            L: 'astigmatismDkL',
            formatter: formatters.diopter,
          },
          {
            label: 'K1 (Flat plano)',
            R: ['k1R', 'k1AxisR'],
            L: ['k1L', 'k1AxisL'],
            formatter: this.formatKeratometry,
          },
          {
            label: 'K2 (Steep curvo)',
            R: ['k2R', 'k2AxisR'],
            L: ['k2L', 'k2AxisL'],
            formatter: this.formatKeratometry,
          },
          {
            label: 'Cornea asphericity (Q)',
            R: 'corneaAsphericityR',
            L: 'corneaAsphericityL',
            formatter: v => formatters.number(v, 2),
          },
          {
            label: 'Cornea SA',
            R: 'corneaSaR',
            L: 'corneaSaL',
            formatter: v => formatters.micron(v, 3),
          },
          {
            label: 'Clinical Keratoconus',
            R: 'keratoconusR',
            L: 'keratoconusL',
            formatter: v => v || '',
          },
          {
            label: 'Pupil Photopic',
            R: 'pupilPhotopicR',
            L: 'pupilPhotopicL',
            formatter: v => formatters.millimeter(v, 2),
          },
          {
            label: 'Pupil Mesopic',
            R: 'pupilMesopicR',
            L: 'pupilMesopicL',
            formatter: formatters.millimeter,
          },
          {
            label: 'Kmax',
            R: 'kmaxR',
            L: 'kmaxL',
            formatter: formatters.diopter,
          },
        ],
      },
    };
  },
  methods: {
    formatKeratometry(value, axis) {
      if (!value && !axis) return '';
      return [formatters.diopter(value), formatters.deg(axis)].filter(v => v !== '').join(' @ ');
    },
  },
};
</script>

<style lang="scss">
@import "@/assets/scss/_variables";
</style>
